import random from 'lodash/random';

const _random = random
export default _random;
